<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="ch00_fm05"></a><a id="page_v"></a><em>This book is dedicated to the people of the<br/>Thought Leader Gathering, Art of Convening Training,<br/>and Heartland communities,<br/>whose loving support has sustained the<br/>evolution of this book.</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?1025aa30